import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    buttonGroup: {
      width: '100%',
      '& .MuiButtonGroup-groupedOutlinedHorizontal:not(:first-child)': {
        marginLeft: 0,
      }
    },
    button25: {
      width: '25%',

    },
    button20: {
      flex: 1
    },
    button: {
      fontSize: 14,
      fontWeight: 400,
      textTransform: 'none',
      background: props.color5,
      color: props.color1,
      "-webkit-box-shadow": "0 1px 2px 0 rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.12)",
      "-moz-box-shadow": "0 1px 2px 0 rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.12)",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.12)",
      padding: "6px 35px",
      border: 'none',
      '&:hover': {
        background: props.rgba,
        color: props.color2,
      },
    },
    selected: {
      color: props.color6,
      background: props.color3,
      '&:hover': {
        color: props.color6,
        background: props.color3,
      }
    }

  }));
  return styles();
}
export default theme;

